var map = {
	"./boxeo.gif": 8302,
	"./davs.jpg": 2805,
	"./home/demo.mp4": 4594,
	"./home/demo_old.mp4": 2913,
	"./home/home-image.jpg": 9277,
	"./logos/Adobe_After_Effects_CC_icon.svg": 7719,
	"./logos/Adobe_Photoshop_CC_icon.svg": 9120,
	"./logos/Adobe_Photoshop_Lightroom_CC_logo.svg": 9654,
	"./logos/Adobe_Premiere_Pro_CC_icon.svg": 7702,
	"./logos/Blender_logo_no_text.svg": 1487,
	"./logos/DaVinci_Resolve_17_logo.svg": 5433,
	"./logos/maya.svg": 7323,
	"./naiki.jpg": 1623,
	"./projects/01.jpg": 9049,
	"./projects/02.jpg": 9571,
	"./projects/03.jpg": 1926,
	"./projects/04.jpg": 7143,
	"./twd.gif": 1133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1995;